// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',

  activeUrl: '',
  activePageName:'', 
  activeUniqueId:'',

    //  baseUrl: 'http://ec2-15-185-68-50.me-south-1.compute.amazonaws.com:8051/api/',//live
    //  reportUrl: 'http://ec2-15-185-68-50.me-south-1.compute.amazonaws.com:8052/'
      // baseUrl: 'http://216.48.184.187:8054/api/',//Test
      // reportUrl: 'http://216.48.184.187:8055/'

    //  baseUrl: 'http://216.48.184.187:8051/api/',//live
    //  reportUrl: 'http://216.48.184.187:8052/'

      // baseUrl: 'http://216.48.184.187:8084/api/',
    // reportUrl: 'http://216.48.184.187:8082/apireport/',

      baseUrl: 'https://localhost:44371/api/',
      reportUrl: 'http://localhost:52499/',
      
      baseUrlCsp: 'http://localhost:50963/api/',
      reportUrlCsp: 'http://localhost:52499/',

     // CrmbaseUrl: 'http://localhost:50963/api/',
        CrmbaseUrl: 'http://localhost:5000/api/',
      BiometricbaseUrl:'http://localhost:5000/api/',
  
      logoType: 'product' ,  // 'product' or 'client'
      MultiTenant:false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


